/* eslint-disable jira/filename-case */
export const NUM_OF_RESULTS_PREVIEW = 5;
export const VERTICAL_BAR_DECODED = '|';
export const VERTICAL_BAR_ENCODED = '%7C';
